export default function CIf() {
  return <h2>C If</h2>;
}
